import React, { useState } from 'react';
import { TabView, TabPanel } from 'primereact/tabview';
import { useSearchParams } from 'react-router-dom';
import UsuariosPanel from './UsuariosPanel';
import EmpresaPage from './EmpresaPage';
import './EmpresaPage.css';
import './PerfilPage.css';

export default function PerfilPage() {
  const [searchParams] = useSearchParams();
  const tabParam = searchParams.get('tab');
  const initialIndex = tabParam === 'empresa' ? 1 : 0;
  const [activeIndex, setActiveIndex] = useState(initialIndex);

  return (
    <div className="perfil-page">
      <h1>Perfil</h1>
      <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} className="perfil-tabs">
        <TabPanel header="Usuários">
          <UsuariosPanel />
        </TabPanel>
        <TabPanel header="Empresa e filiais">
          <EmpresaPage embedded />
        </TabPanel>
      </TabView>
    </div>
  );
}
